import { render, staticRenderFns } from "./people-spider-image.vue?vue&type=template&id=6fa6635f&scoped=true&"
import script from "./people-spider-image.vue?vue&type=script&lang=js&"
export * from "./people-spider-image.vue?vue&type=script&lang=js&"
import style0 from "./people-spider-image.vue?vue&type=style&index=0&id=6fa6635f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6635f",
  null
  
)

export default component.exports